import { useEffect } from 'react';
import { useNavigationType } from 'react-router-dom';
import { useAppDispatch } from 'app/hooks';
import { globalActions } from 'app/services/global/slice';
import { actions as loggerAccess } from 'app/services/loggers/slice';

// Back/Forward into the anonymous logger flow ends the verified access - whether the router replays a POP or the
// browser restores the frozen page from its back-forward cache (pageshow.persisted). The flow itself only replaces.
export const useRevokeOnHistoryNavigation = () => {
  const dispatch = useAppDispatch();
  const viaHistory = useNavigationType() === 'POP';

  const revoke = () => {
    dispatch(loggerAccess.revoke());
    dispatch(globalActions.closeDrawer());
  };

  useEffect(() => {
    if (viaHistory) revoke();
  }, [ viaHistory ]);

  useEffect(() => {
    const onPageShow = (event: PageTransitionEvent) => { if (event.persisted) revoke(); };
    window.addEventListener('pageshow', onPageShow);
    return () => window.removeEventListener('pageshow', onPageShow);
  }, []);

  return viaHistory;
};
